import type { ReactNode } from 'react';

export const symbol_text_select_move_up: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M800-120H160q-13 0-21.5-8.5T130-150q0-13 8.5-21.5T160-180h640q13 0 21.5 8.5T830-150q0 13-8.5 21.5T800-120ZM450-551l-53 52q-9 8-21 8.5t-21-8.5q-9-9-9-21t9-21l104-104q9-9 21-9t21 9l104 104q9 9 9 21t-9 21q-9 9-21 8.5t-21-8.5l-53-52v231q0 13-8.5 21.5T480-290q-13 0-21.5-8.5T450-320v-231Zm350-229H160q-13 0-21.5-8.5T130-810q0-13 8.5-21.5T160-840h640q13 0 21.5 8.5T830-810q0 13-8.5 21.5T800-780Z"
		/>
	</svg>
);
